var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#D8D359"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5h-1V17h1v-2.5zM15 12h-1v5h1v-5zM9.5 17A2.503 2.503 0 0 1 7 14.5h1A1.5 1.5 0 1 0 9.5 13v-1a2.5 2.5 0 0 1 0 5z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6a1 1 0 0 0-1 1v12a1.001 1.001 0 0 0 1 1h12a1.001 1.001 0 0 0 1-1V6a1.001 1.001 0 0 0-1-1zm0 4.5h-7V6h7v3.5zM10 6v3.5H6V6h4zM6 18v-7.5h12l.001 7.5H6z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActiveIcon);
export default __webpack_public_path__ + "static/media/dashboardActiveIcon.27ee7d90caef2f7b4e6de3c02f099485.svg";
export { ForwardRef as ReactComponent };